<template>
  <div class="wrap wrap-tec">
    <div class="cover">
      <img src="@/assets/img/products/recombinant-cells-protein-expression/cover.png" class="img-fluid" alt="快速重组抗体与蛋白">
    </div>
    <div class="content">
      <p class="desc mt20">
        重组抗体技术是现代生物技术领域的一项重要成就，它通过基因工程技术生产出具有高度专一性和亲和力的抗体，通常在HEK293或者CHO细胞中表达，可以大规模生产，满足临床和商业需求。具有易于改造，优于传统杂交瘤方法制备抗体，也减少了实验动物的需求，可用于开发新型治疗药物，如靶向治疗癌症、自身免疫疾病和其他疾病的生物制剂，同时对于诊断类试剂盒的研发发挥着越来越重要的作用，为人类健康带来了巨大的益处。
      </p>
      <div class="c-title">服务类型<small class="mt20">Service type</small></div>
      <div class="desc">擎科生物的重组抗体表达服务是建立在Expi293和CHO-K1的基础上开发的高效瞬时转染工艺，能够快速、高质量表达重组抗体。最快7天可实现从基因合成到毫克级表达纯化；快至14天可实现g级别的表达。</div>
      <div class="mt50 desc">快速重组抗体表达：</div>
      <table class="table mt20">
        <tr>
          <th>项目内容</th>
          <th>表达系统</th>
          <th>服务编号</th>
          <th>体系</th>
          <th>周期</th>
          <th>价格</th>
        </tr>
        <tr v-for="subList in firstTableData" :key="subList[0].content">
          <td v-for="{ content, span } in subList" :key="content" :rowspan="span">{{ content }}</td>
        </tr>
      </table>
      <div class="mt50 desc">重组蛋白表达：</div>
      <table class="table mt20">
        <tr>
          <th>服务名称</th>
          <th>服务编号</th>
          <th>服务内容</th>
          <th>周期</th>
        </tr>
        <tr v-for="(subList, index) in secondTableData" :key="subList[0].content + index">
          <td v-for="{ content, span } in subList" :key="content" :rowspan="span || 1">{{ content }}</td>
        </tr>
      </table>
      <table class="table left-align-table mt100">
        <tr>
          <th>表达系统</th>
          <th>优点</th>
          <th>缺点</th>
          <th>应用领域</th>
        </tr>
        <tr v-for="subList in thirdTableData" :key="subList[0].content">
          <td v-for="({ content, span }, i) in subList" width="25%" :class="[[1, 2].includes(i) ? 'align-left' : '']"
            :key="content" :rowspan="span || 1">{{ content }}</td>
        </tr>
      </table>
    </div>
    <div class="compose-type1 service mt100">
      <div class="container">
        <div class="c-title">服务优势<small class="mt20">Service advantage</small></div>
        <div class="neirong" style="display: flex">
          <div  class="left ">
            <img src="@/assets/img/products/recombinant-cells-protein-expression/advantage.png" alt="">
          </div>
          <div class="right">
            <div class="required" style="background: #F7FBFE;">
              <p class="mb20">周期快：一站式表达服务平台，拥有完善的核定区骨架载体，从设计合成到表达纯化交付，无缝衔接，最快一周交付，为客户节约时间；</p>
              <p class="mb20">高表达：高密度转染工艺，优化改造过的表达菌株，完善的中间过程控制，优秀的密码子优化系统，从整体上提高抗体表达量；</p>
              <p class="mb20">高通量：完善的质粒合成和抽提平台，单次超过1000条的抗体表达纯化通量；</p>
              <p>高交付率：团队成熟，经验丰富，整体抗体交付量>95%。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <qk-consult type="orderForm" />
  </div>
</template>

<script>
import { firstTableData, secondTableData, thirdTableData } from './constants'
export default {
  name: 'RecombinantCellsProteinExpression',
  data() {
    this.firstTableData = firstTableData
    this.secondTableData = secondTableData
    this.thirdTableData = thirdTableData
    return {}
  }
}
</script>

<style lang="scss" scoped>
.desc {
  font-size: 16px;
}

.mt100 {
  margin-top: 100px;
}

.left-align-table {
  white-space: pre-line;

  .align-left {
    padding-left: 15px;
    text-align: left;
  }
}

.content {
  padding: 0 18.5vw;

  .title-text {
    font-weight: 500;
    font-size: 20px;
  }
}


.service {
  background: #F7FBFE;
  padding-bottom: 60px;

  .c-title {
    padding: 60px 0;
  }

  .content {
    display: flex;
    img{
      width: 100%;
    }
    &-text {
      font-size: 16px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }
}

@media screen and (max-width: 640px) {
  .table th {
    padding: 10px;
  }

  .content {
    padding: 0 10vw;
  }

  .service {
    .content {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/products/recombinant-cells-protein-expression/index.vue